import { render, staticRenderFns } from "./expanded-note.vue?vue&type=template&id=15d6505c&"
import script from "./expanded-note.vue?vue&type=script&lang=js&"
export * from "./expanded-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports